import { render } from "./PaginationLast.vue?vue&type=template&id=019b0cff&ts=true"
import script from "./PaginationLast.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaginationLast.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/pagination/PaginationLast.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "019b0cff"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('019b0cff', __exports__)) {
    api.reload('019b0cff', __exports__)
  }
  
  module.hot.accept("./PaginationLast.vue?vue&type=template&id=019b0cff&ts=true", () => {
    api.rerender('019b0cff', render)
  })

}


export default __exports__